export { PageRolesFormComponent as PageRolesDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/roles-form/index.tsx